// removed by extract-text-webpack-plugin
module.exports = {"block":"_3nD0SodYxxV9CbagODf7qB","content":"jwCMoJvtGu_Y0sazUNeY","icon-container":"_1MrUM23je3Fy6XXI4XsJly"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CookieBlock/CookieBlock.module.scss
// module id = 744
// module chunks = 0